import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Anchor from './Anchor';
export var PageNotificationColorCode;
(function (PageNotificationColorCode) {
    PageNotificationColorCode["WHITE"] = "WHITE";
    PageNotificationColorCode["LIGHT_BLUE"] = "LIGHT_BLUE";
})(PageNotificationColorCode || (PageNotificationColorCode = {}));
const PageNotification = ({ localStorageKey, onVisibilityChange, colorCode, hideMargin = false, children }) => {
    const [display, setDisplay] = useState(false);
    useEffect(() => {
        if (typeof (localStorage) !== 'undefined') {
            if (!localStorage.getItem(localStorageKey)) {
                setDisplay(true);
                if (onVisibilityChange) {
                    onVisibilityChange(true);
                }
            }
        }
    }, []);
    const closeNotification = () => {
        if (typeof (localStorage) !== 'undefined') {
            localStorage.setItem(localStorageKey, 'true');
        }
        setDisplay(false);
        if (onVisibilityChange) {
            onVisibilityChange(false);
        }
    };
    return (React.createElement(React.Fragment, null, display &&
        React.createElement(React.Fragment, null,
            React.createElement(NotificationWrapper, { colorCode: colorCode, hideMargin: hideMargin },
                children,
                React.createElement(NotificationCloseComponent, { onClick: closeNotification, "data-testid": 'pageNotification_closeBtn' }, "\u2715")))));
};
export const NotificationWrapper = styled('div') `
  
    display: flex;
    
    flex-direction: column;  
    margin:20px;
    margin: ${props => props.hideMargin && `0px 0px 20px 0px`} !important;
    position:relative;
    padding: 34px 0;

    background: #FFFFFF;
    background: ${props => props.colorCode && props.colorCode === PageNotificationColorCode.WHITE && props.theme.colors.white};
    background: ${props => props.colorCode && props.colorCode === PageNotificationColorCode.LIGHT_BLUE && props.theme.colors.backgroundBlueLighter};
    box-shadow: 0 0 7px 0 rgba(0,0,0,0.10);
    border-radius: 4px;
    
    ::before {
        
        left: 0;
        height:100%;
        position: absolute;
        top: 0;
        width:8px;
        
        background-image: linear-gradient(#00B6E0,#099AC6);
        border-radius: 4px 0 0 4px;
        content: '';
    }
`;
export const NotificationCloseComponent = styled.span `

    position: absolute;
    top: 28px;
    right: 28px;
    
    font-family: ${props => props.theme.fonts.regular};
    font-size: 23px;
    color: #099AC6;
    cursor: pointer;
    line-height: 34px;
`;
export const SubText = styled.span `
    
    font-family: ${props => props.theme.fonts.roman};
    font-size: 16px;
    text-align: center;
    line-height: 27px;
    color: #20AFD7;
    
    padding: 0 50px;
`;
export const SubTextLink = styled(Anchor) `
    margin: 0 5px;
    
    font-family: ${props => props.theme.fonts.black};
    font-size: 16px;
    text-align: center;
    line-height: 27px;
    color: #20AFD7;
    
    cursor: pointer;
`;
export default PageNotification;
//# sourceMappingURL=PageNotification.js.map